/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { REMOTE_COLLECTION } from '../apiUrls';
import { buildUrl } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import remoteCollectionFields from '../../fields/remoteCollectionFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.label string
 * @param responseData.provider string
 * @param responseData.status string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param response
 * @param responseData.items
 * @param responseData.totalPartialResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalPartialResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [remoteCollectionFields.UUID.key]: item[remoteCollectionFields.UUID.key],
            [remoteCollectionFields.LOCAL_TRANSACTION_DATE_TIME.key]: item[remoteCollectionFields.LOCAL_TRANSACTION_DATE_TIME.key],
            [remoteCollectionFields.APPLICATION.key]: item[remoteCollectionFields.APPLICATION.key],
            [remoteCollectionFields.CB_VERSION.key]: item[remoteCollectionFields.CB_VERSION.key],
            [remoteCollectionFields.CONTRACT.key]: item[remoteCollectionFields.CONTRACT.key],
            [remoteCollectionFields.RANK.key]: item[remoteCollectionFields.RANK.key],
            [remoteCollectionFields.RECONCILIATION_NUMBER.key]: item[remoteCollectionFields.RECONCILIATION_NUMBER.key],
            [remoteCollectionFields.POS_REMITTANCE_NUMBER.key]: item[remoteCollectionFields.POS_REMITTANCE_NUMBER.key],
            [remoteCollectionFields.TOTAL_AMOUNT.key]: item[remoteCollectionFields.TOTAL_AMOUNT.key],
            [remoteCollectionFields.RECONCILIATION_CODE.key]: item[remoteCollectionFields.RECONCILIATION_CODE.key],
            [remoteCollectionFields.TRANSACTION_COUNT.key]: item[remoteCollectionFields.TRANSACTION_COUNT.key],
            [remoteCollectionFields.BANK_CODE.key]: item[remoteCollectionFields.BANK_CODE.key],
            [remoteCollectionFields.LEGAL_NAME.key]: item[remoteCollectionFields.LEGAL_NAME.key],
            [remoteCollectionFields.REGISTRATION_NUMBER.key]: item[remoteCollectionFields.REGISTRATION_NUMBER.key],
            [remoteCollectionFields.POS_TERMINAL.key]: {
                [remoteCollectionFields.POS_TERMINAL.UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.POS_TERMINAL.UUID)),
                [remoteCollectionFields.POS_TERMINAL.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.POS_TERMINAL.LABEL)),
                [remoteCollectionFields.POS_TERMINAL.CUSTOM_LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.POS_TERMINAL.CUSTOM_LABEL)),
                [remoteCollectionFields.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.POS_TERMINAL.SERIAL_NUMBER)),
                [remoteCollectionFields.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.POS_TERMINAL.MANUFACTURER))
            },
            [remoteCollectionFields.SUBSCRIPTION.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(remoteCollectionFields.SUBSCRIPTION))
        };
    });

    data.items = mappedItems;
    data.totalPartialResults = totalPartialResults;
    return data;
}

const queryGetRemoteCollections = (query, enabled) => {
    return {
        queryKey: [REMOTE_COLLECTION.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(REMOTE_COLLECTION.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetRemoteCollections;